
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/auglysendur",
      function () {
        return require("private-next-pages/um/fyrirtaekid/auglysendur.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/auglysendur"])
      });
    }
  